/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-16T19:11:22.061
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousebig-'

export default 
{
path: '/rentmanage/renthousebig',
name: 'rentmanage-renthousebig',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousebig-index',

meta:{
...meta,
title: '房源信息'
},

component: () => import('@/pages/rentmanage/renthousebig/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousebig-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源信息编辑'
},

component: () => import('@/pages/rentmanage/renthousebig/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousebigdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源信息新增'
},

component: () => import('@/pages/rentmanage/renthousebig/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousebigView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房源信息查看'
},

component: () => import('@/pages/rentmanage/renthousebig/detail-view') ,
},
]
};
